import { notificationType } from '@/helpers/enums';

export const notificationOptions = {
	icon: '/favicon.png',
	dir: 'rtl',
	lang: 'en-US',
};

// where clicking a notification should navigate, keyed by its `type` — used only when
// the notification itself doesn't carry an explicit redirectUrl/url
export const notificationPageRedirect = {
	[notificationType.materialTransaction]: { name: 'products', query: { tab: 'unreceived-samples' } },
};

// TODO: صفحات لا يُعرض فيها الإشعار المنبثق (مثلاً صفحة الإشعارات نفسها)
export const preventedPagesFromNotification = [];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyDL_jfDaLLi2EuhpRlHe58XPmffsgqzkSI',
		authDomain: 'octopharma-f4d59.firebaseapp.com',
		projectId: 'octopharma-f4d59',
		storageBucket: 'octopharma-f4d59.firebasestorage.app',
		messagingSenderId: '961253865724',
		appId: '1:961253865724:web:0006fc5ccac28967e4ff79'
	},
	publicKey: 'BKXNliInu0ZBwGiNc731ORPxqs19KFVO-IgH8NSi9GwI4WAq_o3NHn_H9zxZTijVQVVTb8lc6-DBLqZSeZOwwgw',
};
